<template>
  <div>
    <div class="order-list" v-for="(item,index) in orderList.records" :key="index">
      <div class="title">
        <span>订单号：{{item.sno}}</span>
        <span>
          {{item.status.desc}}
          <!-- <van-count-down :time="time" v-if="item.status.value == 1" /> -->
        </span>
      </div>
      <div :class="item.rotate ? 'open-wrap' : 'close-wrap'" @click="toOrderDetail(item.sno)">
        <div v-for="(list,index) in item.detailVOS" :key="index">
          <van-card
            :num="list.qty"
            :price="list.unitPrice"
            :title="list.sno"
            :thumb="list.imgAddress"
          >
            <div slot="desc" class="brand">
              <p>{{list.brand}}</p>
              <p>封装规格：{{list.pack}}</p>
            </div>
          </van-card>
        </div>
      </div>
      <!-- 件数 -->
      <div class="piece" @click="orderListOpen(item)" v-if="item.detailVOS.length > 1">
        <span>共{{item.detailVOS.length}}件</span>
        <van-icon
          name="arrow-down"
          style="vertical-align:-1px;margin-left:5px"
          :class="item.rotate ? 'up-arrow' :'bottom-arrow'"
        />
      </div>
      <!-- 实付 -->
      <p class="actually-paid">实付：{{item.totalAmount}}</p>
      <!-- btn -->
      <div class="btn">
        <!-- <div v-if="item.status.value == 3">
          <button>提醒发货</button>
        </div>-->
        <div v-if="item.status.value == 5">
          <button class="receipt" @click="$emit('receipt',item.sno)">确认收货</button>
        </div>
        <!-- <div v-if="item.status.value == 7">
          <button @click="logistics(item.sno)">查看物流</button>
        </div>-->
        <div v-if="item.status.value == 9">
          <button class="receipt" @click="$emit('lifting',item.sno)">确认自提</button>
        </div>
        <div v-if="item.status.value == 1">
          <button @click="$emit('cancel',item.sno)">取消订单</button>
          <button class="btn-last" @click="goPayment(item)">去支付</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "order-list",
  data() {
    return {
      //   tabList: ['全部','待付款','待发货','待自提','已完成']
      time: 30 * 60 * 60 * 1000,
      rotate: false
    };
  },
  created() {},
  props: {
    orderList: Object
  },
  methods: {
    orderListOpen(item) {
      item.rotate = !item.rotate;
    },

    //订单状态详情
    toOrderDetail(item) {
      this.$router.push({
        name: "order-status",
        query: {
          sno: item
        }
      });
    },
    //去支付
    goPayment(item) {
      if (item.payType.value == 1 || item.payType.value == 2) {
        this.$router.push({
          name: "alipy",
          query: {
            sno: item.sno
          }
        });
      } else {
        this.$router.push({
          name: "offline-pay",
          query: {
            sno: item.sno
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.order-list {
  background: #fff;
  border-bottom: 20px solid #f5f5f5;
  .title {
    height: 82px;
    line-height: 82px;
    font-size: 24px;
    color: #666;
    padding: 0 30px;
    span:last-child {
      float: right;
      color: #ff6600;
    }
  }
  .brand {
    color: #666;
    font-size: 26px;
    line-height: 40px;
  }
  .open-wrap {
    height: auto;
  }
  .close-wrap {
    height: 200px;
    overflow: hidden;
  }
  .piece {
    width: 690px;
    height: 45px;
    line-height: 45px;
    background: #e6e6e6;
    text-align: center;
    margin: 0 30px;
    font-size: 26px;
    .up-arrow {
      transition: 0.3s;
      transform: rotate(180deg);
    }
    .bottom-arrow {
      transition: 0.3s;
      transform: rotate(0);
    }
  }
  .actually-paid {
    text-align: right;
    font-size: 26px;
    padding: 30px 30px 30px 0;
  }
  .btn {
    text-align: right;
    padding: 25px 0;
    border-top: 1px solid #f2f2f2;
    button {
      width: 230px;
      height: 70px;
      border: 1px solid #c4c4c4;
      background: #fff;
      font-size: 26px;
      color: #333;
      border-radius: 10px;
    }
    button:last-child {
      margin: 0 30px 0 15px;
    }
    .btn-last {
      background: #ff6600;
      color: #fff;
      border: none;
    }
    .receipt {
      border-color: #ff9900;
      color: #ff9900;
    }
  }
}
.van-card__thumb {
  width: 150px;
  height: 150px;
  margin-right: 20px;
  border: 1px solid #f2f2f2;
}
.van-card {
  padding: 20px 30px;
  background: #fff;
}
.van-card__title {
  font-size: 30px;
  color: #333;
  line-height: 40px;
  margin-bottom: 5px;
  max-height: 6.267vw;
}
.van-card__price {
  font-size: 26px;
  color: #333;
  margin-top: 12px;
}
.van-card:not(:first-child) {
  margin-top: 0;
  border-top: 1px solid #f2f2f2;
}
</style>